import React from "react";
import { Table, Pagination, CircularProgress, ButtonMenu } from "@ann/web-components";
import Filters from "../Filters";
import Icon from "../../../../../../../../../elements/icon/Icon";
import {
  TableWrapper,
  TableContainer,
  TableScrollArea,
  PaginationWrapper,
  LoadingContainer,
  NoDataWrapper,
  NoDataTitle,
  NoDataDescription,
} from "./UserTableSection.styled";

const UserTableSection = ({
  tableData,
  headers,
  currentPage,
  itemsPerPage,
  onItemsPerPageChange,
  onPageChange,
  totalItems,
  totalPages,
  loading,
  onSortChange,
  onOrderChange,
  selectedSortOption,
  orderDirection,
  onSearchChange,
  onRoleChange,
  onPermissionsChange,
}) => {
  const showEmptyState = !loading && tableData.length === 0;

  // Permission options for ButtonMenu in table cells
  const permissionOptions = [
    { label: "View", value: "View" },
    { label: "Edit", value: "Edit" },
    { label: "Suggest", value: "Suggest" },
  ];

  return (
    <TableWrapper>
      <TableContainer>
        <Filters
          onSortChange={onSortChange}
          onOrderChange={onOrderChange}
          selectedSortOption={selectedSortOption}
          orderDirection={orderDirection}
          onSearchChange={onSearchChange}
          onRoleChange={onRoleChange}
          onPermissionsChange={onPermissionsChange}
          loading={loading}
        />
        <TableScrollArea>
          {loading ? (
            <LoadingContainer>
              <CircularProgress size="xl" />
            </LoadingContainer>
          ) : showEmptyState ? (
            <NoDataWrapper>
              <Icon name="noDataAvailable" width="201px" height="195px" />
              <NoDataTitle>No users yet</NoDataTitle>
              <NoDataDescription>
                No users found.
              </NoDataDescription>
            </NoDataWrapper>
          ) : (
            <Table
              data={tableData}
              headers={headers}
              mode="table"
              showActions={false}
            />
          )}
        </TableScrollArea>
      </TableContainer>
      {!showEmptyState && (
        <PaginationWrapper>
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={onItemsPerPageChange}
            onPageChange={onPageChange}
            totalItems={totalItems}
            totalPages={totalPages}
            disabled={loading}
          />
        </PaginationWrapper>
      )}
    </TableWrapper>
  );
};

export default UserTableSection;

